import {Row} from "antd";
import POCard from "./POCard";
import {useMemo, useState} from "react";
import POModal from "./POModal";
import {epochToDate} from "../../../shared/functions/toDateTime";
import {nanoid} from "@reduxjs/toolkit";

export default function POList({items}) {
    const [isModalShown, setIsModalShown] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    // console.log("IN PO LIst"+JSON.stringify(items))
    console.log(items)
    // console.log(items.Purchases[1])
    console.log(selectedItem)
    
    const list = useMemo(() => {
        if (!items) return [];
        
        
        
        return items.map(item => {
            var total = 0;
            var ind = 0;
            return ({
                id: item.id,
                ref: item.PoRef,
                vendor: item.VendorName,
                warehouse: item.WarehouseName,
                cost:  item.Purchases.map(es => {
                    ind += 1
                    total += (es.Price - es.Discount) * es.Quantity;
                    if(item.Purchases.length === ind && item?.Currency === "FCFA"){ 
                        return total+" FCFA";
                    }else if (item.Purchases.length === ind){
                        return "$ "+total;
                    }
                    /*if(item.Purchases.length === ind && (item?.Currency === "DOLLAR" || item?.Currency === null)){ 
                        return "$ "+total;
                    }*/
                }),
                createdAt:epochToDate(item.CreateAt),
                status: item.ActivityStatus,
                deliveryType: item.DeliveryType,
                username: item.Username,
                Currency: item.Currency,
            })
        })
        
    }, [items])

    // console.log( "lmllllml", items.cost);
    


    const handleModalOpening = () => setIsModalShown(true);
    const handleModalClosing = () => {
        setIsModalShown(false);
        setSelectedItem(null)
    }

    const handleSelection = (id) => {
        items && setSelectedItem(items.find(one => one.id === id))
        handleModalOpening()
    }

    return (
        <section>
            <Row>
                {
                    list && list.map(item => (
                        <POCard
                            key={nanoid()}
                            item={item}
                            onClick={() => handleSelection(item.id)}
                        />
                    ))
                }
            </Row>

            {
                selectedItem && (
                    <POModal
                        items={selectedItem}
                        show={isModalShown}
                        onClose={handleModalClosing}
                    />
                )
            }

        </section>
    )
}
